import { IconButton, Text } from '@wix/design-system';
import { X } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';
import Image from 'next/image';
import React, { FC } from 'react';

import type { SiteMetaData } from '../../../../../../../types';
import { useStore } from '../../../../../../../zustand/stores';
import { siteThumbnail } from '../../../../../../SiteSelector/SiteSelectorList/SiteSelectorListItem';

import css from './index.module.scss';

export type SitePickerSiteListItemProps = {
  site: SiteMetaData;
  onClose: () => void;
  showDivider: boolean;
};

export const SitePickerSiteListItem: FC<SitePickerSiteListItemProps> = ({
  site,
  onClose,
  showDivider,
}) => {
  const { selectedSite, setUserSelectedSite } = useStore(
    (state) => state.siteSelectorSlice
  );
  const isSelected = selectedSite?.metaSiteId === site.metaSiteId;
  const title = site.siteProperties?.siteDisplayName ?? site.name;

  const selectAndClose = () => {
    setUserSelectedSite(site);
    onClose();
  };

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={selectAndClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectAndClose();
          }
        }}
        className={classNames(css.siteRow, {
          [css.siteRowSelected]: isSelected,
        })}
      >
        <Image
          src={siteThumbnail(site.metaSiteId)}
          alt={site.siteProperties?.siteDisplayName ?? site.name ?? ''}
          width={72}
          height={48}
        />
        <Text ellipsis className={css.siteRowTitle}>
          {title}
        </Text>
        {isSelected ? (
          <IconButton
            size="small"
            skin="standard"
            priority="secondary"
            onClick={(e) => {
              e.stopPropagation();
              setUserSelectedSite(null);
            }}
          >
            <X />
          </IconButton>
        ) : null}
      </div>
      {showDivider ? <div className={css.divider} /> : null}
    </>
  );
};
